import { DIFFERENTIATOR } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const DifferentiatorBand = () => {
  return (
    <section
      data-testid="differentiator-band"
      className="relative overflow-hidden"
      style={{
        backgroundColor: "var(--bg-2)",
        borderTop: "1px solid var(--border-c)",
      }}
    >
      {/* Statement */}
      <div className="container-fx py-16 sm:py-24 text-center">
        <Reveal>
          <h2
            className="display mx-auto max-w-4xl"
            style={{ fontSize: "clamp(1.8rem, 4.4vw, 3.1rem)", fontWeight: 500 }}
          >
            No repeated workouts.{" "}
            <span className="accent-italic">No random workouts.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p
            className="mx-auto mt-6 max-w-2xl"
            style={{ color: "var(--text-2)", fontSize: "1.05rem", lineHeight: 1.7 }}
          >
            {DIFFERENTIATOR.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
